import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
  import hexadecimalToRgba from '@/_legacy/util/hexadecimalToRgba';
  import { useConductStore } from '@/stores/conduct/conduct';
  import { useBuilderMode } from '@/ui/concerns/checklist/useBuilderMode';
  import { getTitle } from '@/ui/helpers/formTranslationsHelper';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ConductInspectionItemQuestionListResponse',
  props: {
    response: {
      type: Object,
      required: true,
    },
    selected: {
      type: Boolean,
      required: true,
    },
    hasLongOption: {
      type: Boolean,
      required: false,
    },
  },
  emits: ['click'],
  setup(__props, { emit }) {

const props = __props;

  

  

  const { isTranslationEnabled } = useConductStore();
  const { isTranslationMode } = useBuilderMode();

  const bgColor = computed(() => {
    if (props.selected) {
      return props.response.color;
    }

    return hexadecimalToRgba(props.response.color);
  });

  const color = computed(() => {
    if (props.selected) {
      return '#ffffff';
    }

    return props.response.color;
  });

  const title = computed(() => {
    return getTitle(props.response, isTranslationEnabled || isTranslationMode.value);
  });

  const handleClick = (event: Event) => {
    emit('click', (event.target as HTMLButtonElement).value);
  };

return { __sfc: true,props, emit, isTranslationEnabled, isTranslationMode, bgColor, color, title, handleClick }
}

})